export enum LegacyExamTypeKey {
  TopicExam1 = 'TOPIC_1',
  TopicExam2 = 'TOPIC_2',
  TopicExam3 = 'TOPIC_3',
  MockExam1 = 'MOCK_1',
  MockExam2 = 'MOCK_2',
  MockExam3 = 'MOCK_3',
  ShortQuiz = 'QUIZ_SHORT',
}
